export default __webpack_public_path__ + "static/media/partner-call.efb3631c.wav";